import React, { useEffect, useState } from 'react'
import NavigationBar from '../../components/Navigationbar/Navigationbar'
import Headline from '../../components/headline/Headline'
import { post, Token } from '../../Script/Session';
import { haspermission } from '../../Script/Permission';
import { Autocomplete, Button, Card, FormControl, FormLabel, Input, Link, Typography } from '@mui/joy';

function Foren() {
    const [wit, setWit] = useState("90.5%");
    const [data, setdata] = useState();
    const [perm, setperm] = useState(haspermission("0"));
    const [createforum, setcreateforum] = useState(false);
    const [nameinput, setnameinput] = useState("");
    const [descinput, setdescinput] = useState();
    const [groups, setgroups] = useState([]);
    const [selectedgroup, setselectedgroup] = useState(null);
    useEffect(() => {
        function fetch() {
            let body = {};
            body.token = Token.get();
            body.action = "getforen";
            let response = post(body, "/forum");
            console.log(response);
            setdata(JSON.parse(response)?.result);
        }
        setTimeout(() => {
            fetch()
        }, 15);
    }, []);
    function upadate() {
        let body = {};
        body.token = Token.get();
        body.action = "getforen";
        let response = post(body, "/forum");
        setdata(JSON.parse(response)?.result);
    }
    useEffect(() => {

        const fetchData = async () => {

            try {
                const body = {
                    token: Token.get(),
                    action: "get",
                };

                const response = await post(body, "/editGroups");

                if (!response) {
                    alert("hat einen Fehler!");
                    return;
                }

                const json = JSON.parse(response);
                setgroups(json.values);

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        setTimeout(() => {
            fetchData();
        }, 15);


    }, []);

    function create() {
        let body = {};
        body.token = Token.get();
        body.action = "create_forum";
        body.name = nameinput;
        body.reqrole = selectedgroup != null ? selectedgroup.name : null;
        body.desc = descinput;
        let response = post(body, "/forum");
        upadate();
    }
    function del(delid) {
        let body = {};
        body.token = Token.get();
        body.action = "delete_forum";
        body.id = delid;
        let response = post(body, "/forum");
        upadate();
    }
    return (
        <>
            <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", height: "100vh", display: "flex", alignItems: "center", overflowY: "auto" }}>
                <Headline title={"Forum"} />
                {
                    perm && !createforum && (
                        <Card sx={{ mt: 2, width: "96%" }}>
                            <Typography level="title-md">Bearbeitung</Typography>
                            <Typography mt={-1}>Im folgenden haben sie die Möglichkeit ein neues Forum zu erstellen</Typography>
                            <Button sx={{ width: "10%" }} onClick={() => setcreateforum(true)}>Forum erstellen</Button>
                        </Card>
                    )
                }
                {
                    createforum && (
                        <Card sx={{ mt: 2, width: "96%" }}>
                            <Typography level="title-md">Forum erstellen</Typography>
                            <FormControl>
                                <FormLabel>Name</FormLabel>
                                <Input value={nameinput} onChange={(e) => setnameinput(e.target.value)} placeholder='Forum Name'></Input>
                            </FormControl>
                            <FormControl>
                                <FormLabel>Beschreibung</FormLabel>
                                <Input value={descinput} onChange={(e) => setdescinput(e.target.value)} placeholder='Beschreiben sie kurz um was es im Forum geht'></Input>
                            </FormControl>
                            <FormControl>
                                <FormLabel>Funktion</FormLabel>
                                <Autocomplete options={groups} onChange={(e, newv) => setselectedgroup(newv)} getOptionLabel={(i) => i.name} placeholder='Diese Funktion muss ein Mitglied haben damit es das Forum aufrufen kann. Frei lassen für öffentlich'></Autocomplete>
                            </FormControl>
                            <Button onClick={() => create()} sx={{ width: "10%" }}>
                                Speichern
                            </Button>
                        </Card>
                    )
                }
                {
                    data && data.map((item) => {
                        return (
                            <Card sx={{ mt: 2, width: "96%" }}>
                                <Link href={window.location.origin + "/viewforum/" + item.id}><Typography level="title-md" color="primary">{item.name}</Typography></Link>
                                <Typography>{item.desc}</Typography>
                                {
                                    perm && (
                                        <Button sx={{ width: "8%", mt: 2 }} color="danger" onClick={() => del(item.id)}>Löschen</Button>
                                    )
                                }
                            </Card>
                        )
                    })
                }
                {
                    !data && (
                        <Typography>Wird geladen</Typography>

                    )
                }

            </div>
            <NavigationBar state={"home"} back={false} />
        </>
    )
}

export default Foren
